import styled, { css } from "styled-components";
import { token } from "./token.js";
const indicatorPositionStyles = css(["position:absolute;right:calc(var(--ds-thumbnail-indicator-offset-x) * -1);bottom:calc(var(--ds-thumbnail-indicator-offset-y) * -1);overflow:visible;width:calc(var(--ds-thumbnail-indicator-radius) * 2);height:calc(var(--ds-thumbnail-indicator-radius) * 2);"]);
const SvgIcon = styled.svg.withConfig({
  displayName: "SvgIcon",
  componentId: "sc-18umtiy-0"
})(["", ""], indicatorPositionStyles);
const IconContainer = styled.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-18umtiy-1"
})(["", " display:flex;justify-content:center;align-items:center;border-radius:50%;background-color:", ";color:", ";svg{width:12px;height:12px;}"], indicatorPositionStyles, ({
  $backgroundColor: backgroundColor
}) => token[backgroundColor], ({
  $iconColor: iconColor
}) => token[iconColor]);
export {
  IconContainer,
  SvgIcon
};
//# sourceMappingURL=styles2.js.map
